module.exports = __webpack_public_path__ + "img/chevron_right_icon.4a804d5b.svg";